import { render, staticRenderFns } from "./kisaeIndex.vue?vue&type=template&id=879351c8&scoped=true"
import script from "./kisaeIndex.vue?vue&type=script&lang=js"
export * from "./kisaeIndex.vue?vue&type=script&lang=js"
import style0 from "./kisaeIndex.vue?vue&type=style&index=0&id=879351c8&prod&lang=scss&scoped=true"
import style1 from "./kisaeIndex.vue?vue&type=style&index=1&id=879351c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879351c8",
  null
  
)

export default component.exports